import { Injectable } from '@angular/core';
import { Response, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AuthHttpService } from 'app/security/authorization';
import { environment } from 'environments/environment';
import { Company, CompanyId } from './company.model';
import { CompanyMapper } from './company.mapper';
import { Department, DepartmentId } from './department.model';
import { DepartmentMapper } from './department.mapper';
import { Industry, IndustryId } from './industry.model';
import { IndustryMapper } from './industry.mapper';

@Injectable()
export class WorkRecordRepository {

  constructor(
    private authHttp: AuthHttpService
  ) { }

  public companyAutocomplete(name: string): Observable<Company[]> {
    const params: URLSearchParams = new URLSearchParams();
    params.set('name', name);

    const requestOptions = new RequestOptions();
    requestOptions.search = params;

    return this.authHttp.get(
        environment.apiUrl + 'company',
        requestOptions
      )
      .map(response => response.json())
      .map((list: any): Company[] => list.map(CompanyMapper.map));
  }

  public companyCreate(company: Company): Observable<{ id: CompanyId }> {
    return this.authHttp.post(
        environment.apiUrl + 'company',
        company
      )
      .map((response: Response): { id: CompanyId } => response.json());
  }

  public companyUpdate(company: Company, companyId: CompanyId) {
    return this.authHttp.put(
        environment.apiUrl + 'company/' + companyId,
        company
      );
  }

  public departmentAutocomplete(name: string): Observable<Department[]> {
    const params: URLSearchParams = new URLSearchParams();
    params.set('name', name);

    const requestOptions = new RequestOptions();
    requestOptions.search = params;

    return this.authHttp.get(
        environment.apiUrl + 'department',
        requestOptions
      )
      .map(response => response.json())
      .map((list: any): Department[] => list.map(DepartmentMapper.map));
  }

  public departmentCreate(name: string): Observable<{ id: DepartmentId }>  {
    return this.authHttp.post(
        environment.apiUrl + 'department',
        { name }
      )
      .map((response: Response): { id: DepartmentId } => response.json());
  }

  public departmentUpdate(
    departmentId: DepartmentId,
    name: string
  ) {
    return this.authHttp.put(
        environment.apiUrl + 'department/' + departmentId,
        { name }
      );
  }

  public industryAutocomplete(name: string): Observable<Industry[]> {
    const params: URLSearchParams = new URLSearchParams();
    params.set('name', name);

    const requestOptions = new RequestOptions();
    requestOptions.search = params;

    return this.authHttp.get(
        environment.apiUrl + 'industry',
        requestOptions
      )
      .map(response => response.json())
      .map((list: any): Industry[] => list.map(IndustryMapper.map));
  }

  public industryCreate(name: string): Observable<{ id: DepartmentId }>  {
    return this.authHttp.post(
        environment.apiUrl + 'industry',
        { name }
      )
      .map((response: Response): { id: IndustryId } => response.json());
  }

  public industryUpdate(
    industryId: IndustryId,
    name: string
  ) {
    return this.authHttp.put(
        environment.apiUrl + 'industry/' + industryId,
        { name }
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/work-record.repository.ts